import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { ColDef, GridApi} from 'ag-grid-community';
import { moduloConciliacionBan } from '../../diccionarios/conciliacionBancariaModulo'
import { Banco } from '../../models/recuadosBancario/ParamExtracionBanca';
import { ReglasOperacionBancariaService } from '../../services/reglas-banca/reglas-banca.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { RecaudoBancarioService } from '../../services/recaudoBancario/recaudo-bancario.service';

@Component({
  selector: 'app-param-conci-extracto-feriados',
  templateUrl: './param-conci-extracto-feriados.component.html',
  styleUrls: ['./param-conci-extracto-feriados.component.css']
})

export class ParamConciExtractoFeriadosComponent implements OnInit {
  public DAT_TITULOS    = moduloConciliacionBan.titulos.Feriados;
  public GLOBAL_TITULOS = moduloConciliacionBan.titulos.global;
  public DAT_AG_GRID    = moduloConciliacionBan.agGrid;

  public titleModal   : string;
  public loading      : boolean = false;
  public isCreate     : boolean = false;

  // variables para el grid
  public frameworkComponents: any;
  public columnDefs     : ColDef[] = [];
  public rowData        : any[] = [];
  public rowSelection   : any;
  public gridApi        : GridApi;
  public gridColumnApi  : any;
  public textoBuscar    : string;
  public usarioActual   : any;

  // variables funcionales
  public listBancos    : Banco [] = [];
  public selected      : any[];

  //Formularios
  public formulario = new FormGroup({
    idConfig        : new FormControl(''),
    bancoId         : new FormControl('', Validators.required),
    fechaInicio     : new FormControl('', Validators.required),
    fechaFin        : new FormControl('', Validators.required),
    creado          : new FormControl(''),
    creadoPor       : new FormControl('',Validators.required),
    modificado      : new FormControl(''),
    modificadoPor   : new FormControl(''),
  });

  constructor(
    private conciliacionApi: ReglasOperacionBancariaService,
    private recaudoApi     : RecaudoBancarioService,
    private utilServices   : UtilsService
  ) { }

  ngOnInit(): void {
    this.usarioActual = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.titleModal   = this.DAT_TITULOS.tituloCardList;
    this.isCreate     = false;
    this.listBancos   = [];    

    this.recaudoApi.cargarBancoEmpresaConfigExtracto('1001').subscribe((resp) => {
      console.log(resp);
      this.listBancos = resp.respuesta;
    }, (error) => {
      this.listBancos = [];
      console.log(error);
    });

    this.listar();
    this.cargarGridcomponent();
  }

  cargarGridcomponent() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent, };
    this.columnDefs = [      
      { field: 'idConfig' , sort:"desc"},
      { field: 'bancoId' },
      { field: 'bancoDescripcion' },
      { field: 'fechaInicio' },
      { field: 'fechaFin' },
      { cellRenderer: 'buttonRenderer', cellRendererParams: {onClick: this.editar.bind(this), label: 'Editar'} },
      { cellRenderer: 'buttonRenderer', cellRendererParams: {onClick: this.delete.bind(this), label: 'Eliminar'} }
    ];

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  //Manejador de popup
  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    this.saveForm();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  //Funciones del CRUD
  listar(){
    this.rowData = [];
    this.conciliacionApi.getAllParamFeriados().subscribe((res) => {
      if(res) this.rowData = res;
    }, (err) => {
      console.info(err.message);
    });
  }

  nuevo() {
    this.isCreate   = true;
    this.titleModal = this.GLOBAL_TITULOS.tituloAgregar;

    this.formulario.reset();
    this.formulario.get('creadoPor').setValue(this.usarioActual.login2);
    this.openModal();
  }

  editar({rowData}){
    this.isCreate   = false;
    this.titleModal = this.GLOBAL_TITULOS.tituloActualizar;

    this.formulario.reset();
    this.formulario.patchValue(rowData);
    this.formulario.get('modificadoPor').setValue(this.usarioActual.login2);
    this.openModal();
  }

  delete({rowData}){
    this.loading = true;
    const idConf = rowData.idConfig;

    this.utilServices.confirmarSincronoPromesa({
        title : moduloConciliacionBan.mensajes.eliminar,
        text  : this.GLOBAL_TITULOS.tituloEliminar,
        action: "Eliminar",
        funcion: this.conciliacionApi.deteleParametrosParamFeriados(idConf),
      }).then((_res: any) => {
        this.listar();
      }).catch(() => {
        this.loading = false;
      });

    this.loading = false;
  }

  /** Si el form esta en modo de creación hará post caso contrario un put.
   * Ver variable isCreated */
  saveForm() {
    if (this.formulario.invalid) return;

    this.loading  = true;
    let mensajeP  = this.isCreate ? moduloConciliacionBan.mensajes.guardar : moduloConciliacionBan.mensajes.actualizar;
    const payload =  this.formulario.getRawValue();

    this.utilServices.confirmarSincronoPromesa({
        title   : mensajeP,
        text    : this.DAT_TITULOS.titulo,
        action  : this.titleModal,
        funcion : this.isCreate ? this.conciliacionApi.guardarParametrosParamFeriados(payload) : this.conciliacionApi.actualizarParamFeriados(payload)
      }).then(() => {
        this.listar();
        this.closeModal();
      }).catch(() => {});

      this.loading = false;
  }

}